<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectedJudicialStatus"
    style="min-width: 220px;"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Status Cobrança
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
import { JUDICIAL_STATUS } from '../../constants';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedJudicialStatus: this.value,
      options: Object.entries(JUDICIAL_STATUS).map(
        ([statusKey, statusText]) => ({
          value: statusKey,
          text: statusText,
        }),
      ),
    };
  },
  methods: {
    handleChange() {
      this.$emit('input', this.selectedJudicialStatus);
    },
  },
};
</script>
